// SPDX-FileCopyrightText: 2022 Genome Research Ltd.
//
// SPDX-License-Identifier: MIT
import axios from "axios";
export function createAxiosInstance(options) {
    // eslint-disable-line
    const axiosInstance = axios.create(options);
    axiosInstance.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        throw error; // TODO: handle error like token expired, ...
    });
    return axiosInstance;
}
